import type { UIStringsOverride } from "../i18n-ui.ts";

/** German (de) UI strings. */
export const de: UIStringsOverride = {
  actions: {
    addToCursor: "Zu Cursor hinzufügen",
    addToVscode: "Zu VS Code hinzufügen",
    askAI: "KI zu dieser Seite fragen",
    connectMcp: "Mit MCP verbinden",
    copied: "Kopiert!",
    copyClaudeCode: "Claude-Code-Befehl kopieren",
    copyCode: "Code kopieren",
    copyCodex: "Codex-Befehl kopieren",
    copyMarkdown: "Als Markdown kopieren",
    copyServerUrl: "Server-URL kopieren",
    edit: "Auf GitHub bearbeiten",
    export: "Exportieren",
    exportEpub: "Als EPUB exportieren",
    exportPdf: "Als PDF exportieren",
    generating: "Wird generiert…",
    openIn: "In {name} öffnen",
    openInChat: "Im Chat öffnen",
    scrollToTop: "Nach oben scrollen",
  },
  ask: {
    ai: "KI",
    clear: "Unterhaltung löschen",
    close: "Schließen",
    copy: "Unterhaltung kopieren",
    empty: "Stelle eine Frage zur Dokumentation.",
    error: "Entschuldigung, etwas ist schiefgelaufen.",
    label: "Eine Frage stellen",
    placeholder: "Eine Frage stellen…",
    send: "Senden",
    tip: "Tipp: Du kannst den Chat öffnen und schließen mit",
    title: "KI fragen",
    you: "Du",
  },
  banner: { dismiss: "Ankündigung schließen" },
  changelog: {
    description: "Produkt-Updates und Versionshinweise.",
    showReleases: "Releases für {version} anzeigen",
    title: "Änderungsprotokoll",
  },
  content: { diagramError: "Dieses Diagramm konnte nicht dargestellt werden." },
  feedback: {
    no: "Nein",
    question: "War diese Seite hilfreich?",
    thanks: "Danke für dein Feedback!",
    yes: "Ja",
  },
  languageSwitcher: { label: "Sprache", untranslated: "Nicht übersetzt" },
  nav: {
    back: "Zurück",
    breadcrumb: "Brotkrümelnavigation",
    closeNavigation: "Navigation schließen",
    deprecated: "veraltet",
    featured: "Empfohlen",
    githubRepository: "GitHub-Repository",
    navigation: "Navigation",
    primary: "Primär",
    sections: "Abschnitte",
    toggleNavigation: "Navigation umschalten",
    toggleTheme: "Farbschema umschalten",
  },
  notFound: {
    description: "Wir konnten die gesuchte Seite nicht finden.",
    home: "Zurück zur Startseite",
    title: "Seite nicht gefunden",
  },
  page: {
    lastUpdated: "Zuletzt aktualisiert am",
    next: "Weiter",
    pagination: "Seitennummerierung",
    previous: "Zurück",
    skipToContent: "Zum Inhalt springen",
  },
  search: {
    all: "Alle",
    allLanguages: "Alle Sprachen",
    askAi: "KI fragen",
    askAiHint: "Erhalte sofort eine Antwort von der KI",
    button: "Suchen",
    devOnly: "Die Suche ist im Produktions-Build verfügbar.",
    error: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
    label: "Dokumentation durchsuchen",
    navigate: "navigieren",
    noResults: "Keine Ergebnisse gefunden.",
    open: "öffnen",
    placeholder: "Dokumentation durchsuchen…",
    popular: "Beliebt",
    preview: "vorschau",
    results: "Ergebnisse",
  },
  toc: { title: "Auf dieser Seite" },
};
